var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.classes},[_c('div',{staticClass:"loading-inner"},[(_vm.text !== '')?_c('div',{staticClass:"loading2",domProps:{"innerHTML":_vm._s(_vm.text)}}):_vm._e(),(_vm.showLogo)?_c('div',{staticClass:"logo"}):_vm._e(),_c('div',{staticClass:"loading3"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }